'use strict';

var novicell = novicell || {};
var nvcl = nvcl || {};

nvcl.helper = nvcl.helper || new function () {
    this.toggleClass = function(el, className) {
        if(el.classList) {
            el.classList.toggle(className);
        } else {
            var classes = el.className.split(' ');
            var existingIndex = classes.indexOf(className);
    
            if (existingIndex >= 0) {
                classes.splice(existingIndex, 1);
            }
            else {
                classes.push(className);
            }
    
            el.className = classes.join(' ');
        }
    };

    this.isVisible = function (element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    };
};